// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"79ec0e15","577":"04c894c5","748":"7fc52c2a"}[chunkId] + ".chunk.js";
};